// @generated by protoc-gen-es v2.14.0 with parameter "target=ts,import_extension=js"
// @generated from file warinspace/v2/common.proto (package warinspace.v2, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file warinspace/v2/common.proto.
 */
export const file_warinspace_v2_common: GenFile = /*@__PURE__*/
  fileDesc("Chp3YXJpbnNwYWNlL3YyL2NvbW1vbi5wcm90bxINd2FyaW5zcGFjZS52MipNCgRUZWFtEhQKEFRFQU1fVU5TUEVDSUZJRUQQABINCglURUFNX0JMVUUQARIMCghURUFNX1JFRBACEhIKDlRFQU1fU1BFQ1RBVE9SEAMqfgoOVGVhbVByZWZlcmVuY2USHwobVEVBTV9QUkVGRVJFTkNFX1VOU1BFQ0lGSUVEEAASGAoUVEVBTV9QUkVGRVJFTkNFX0JMVUUQARIXChNURUFNX1BSRUZFUkVOQ0VfUkVEEAISGAoUVEVBTV9QUkVGRVJFTkNFX0FVVE8QAyrKAgoLUGxheWVyU3RhdGUSHAoYUExBWUVSX1NUQVRFX1VOU1BFQ0lGSUVEEAASHQoZUExBWUVSX1NUQVRFX1RJTUVEX1NISUVMRBABEh8KG1BMQVlFUl9TVEFURV9IRUFMX0lOX1JBRElVUxACEhgKFFBMQVlFUl9TVEFURV9TVEVBTFRIEAMSIAocUExBWUVSX1NUQVRFX1NDUkFQX0lOX1JBRElVUxAEEhsKF1BMQVlFUl9TVEFURV9BQlNPUkJUSU9OEAUSIQodUExBWUVSX1NUQVRFX0RBTUFHRV9JTl9SQURJVVMQBhIfChtQTEFZRVJfU1RBVEVfREFNQUdFX0JPT1NURUQQBxImCiJQTEFZRVJfU1RBVEVfU0VMRl9EQU1BR0VfSU5fUkFESVVTEAgSGAoUUExBWUVSX1NUQVRFX0dPRE1PREUQCSqXAQoGU3RhdElkEhcKE1NUQVRfSURfVU5TUEVDSUZJRUQQABIWChJTVEFUX0lEX01PVkVfU1BFRUQQARIWChJTVEFUX0lEX01BWF9IRUFMVEgQAhIYChRTVEFUX0lEX0ZJUklOR19SQU5HRRADEhIKDlNUQVRfSURfREFNQUdFEAQSFgoSU1RBVF9JRF9NQVhfRFJPTkVTEAUqbgoLVXBncmFkZVBhdGgSHAoYVVBHUkFERV9QQVRIX1VOU1BFQ0lGSUVEEAASFQoRVVBHUkFERV9QQVRIX1pFUk8QARIUChBVUEdSQURFX1BBVEhfT05FEAISFAoQVVBHUkFERV9QQVRIX1RXTxADKpkCCgtMb2dpblN0YXR1cxIcChhMT0dJTl9TVEFUVVNfVU5TUEVDSUZJRUQQABIaChZMT0dJTl9TVEFUVVNfTE9HR0VEX0lOEAESGwoXTE9HSU5fU1RBVFVTX0xPR0dFRF9PVVQQAhIgChxMT0dJTl9TVEFUVVNfQkFEX0NSRURFTlRJQUxTEAMSHwobTE9HSU5fU1RBVFVTX1NFU1NJT05fU1RPTEVOEAQSJgoiTE9HSU5fU1RBVFVTX0xPR0dFRF9PVVRfQU5EX0ZPUkdFVBAFEh4KGkxPR0lOX1NUQVRVU19JTlZBTElEX0VNQUlMEAYSKAokTE9HSU5fU1RBVFVTX1VTRVJOQU1FX09SX0VNQUlMX1RBS0VOEAcqxQEKDk1vZENvbW1hbmRUeXBlEiAKHE1PRF9DT01NQU5EX1RZUEVfVU5TUEVDSUZJRUQQABIgChxNT0RfQ09NTUFORF9UWVBFX0tJTExfUExBWUVSEAESIAocTU9EX0NPTU1BTkRfVFlQRV9LSUNLX1BMQVlFUhACEiMKH01PRF9DT01NQU5EX1RZUEVfUkFORE9NSVNFX05BTUUQAxIiCh5NT0RfQ09NTUFORF9UWVBFX1RPR0dMRV9GUkVFWkUQBCIECAUQBSrYAQoQRGVidWdDb21tYW5kVHlwZRIiCh5ERUJVR19DT01NQU5EX1RZUEVfVU5TUEVDSUZJRUQQABIkCiBERUJVR19DT01NQU5EX1RZUEVfR1JBTlRfQ1JFRElUUxABEicKI0RFQlVHX0NPTU1BTkRfVFlQRV9HUkFOVF9TQ1JBUF9TRUxGEAISKwonREVCVUdfQ09NTUFORF9UWVBFX0dSQU5UX1NDUkFQX0VWRVJZT05FEAMSJAogREVCVUdfQ09NTUFORF9UWVBFX1NFVF9USU1FU0NBTEUQBCqYAQoLUHJvZHVjdFR5cGUSHAoYUFJPRFVDVF9UWVBFX1VOU1BFQ0lGSUVEEAASFgoSUFJPRFVDVF9UWVBFX0RFQ0FMEAESHQoZUFJPRFVDVF9UWVBFX1RBR19PUl9UUkFJTBACEhUKEVBST0RVQ1RfVFlQRV9TS0lOEAMSHQoZUFJPRFVDVF9UWVBFX1BBWU1FTlRfVElMRRAEKm4KD0xvYmJ5VmlzaWJpbGl0eRIgChxMT0JCWV9WSVNJQklMSVRZX1VOU1BFQ0lGSUVEEAASGwoXTE9CQllfVklTSUJJTElUWV9QVUJMSUMQARIcChhMT0JCWV9WSVNJQklMSVRZX1BSSVZBVEUQAiqdAQoNQm90RGlmZmljdWx0eRIeChpCT1RfRElGRklDVUxUWV9VTlNQRUNJRklFRBAAEhoKFkJPVF9ESUZGSUNVTFRZX1JFQ1JVSVQQARIaChZCT1RfRElGRklDVUxUWV9SRUdVTEFSEAISGgoWQk9UX0RJRkZJQ1VMVFlfVkVURVJBThADEhgKFEJPVF9ESUZGSUNVTFRZX0VMSVRFEAQqlwEKEExvYmJ5Q2xvc2VSZWFzb24SIgoeTE9CQllfQ0xPU0VfUkVBU09OX1VOU1BFQ0lGSUVEEAASGwoXTE9CQllfQ0xPU0VfUkVBU09OX0xFRlQQARIiCh5MT0JCWV9DTE9TRV9SRUFTT05fTUFUQ0hfRU5ERUQQAhIeChpMT0JCWV9DTE9TRV9SRUFTT05fUkVUSVJFRBADKmAKE05vdGlmaWNhdGlvblN1YmplY3QSJAogTk9USUZJQ0FUSU9OX1NVQkpFQ1RfVU5TUEVDSUZJRUQQABIjCh9OT1RJRklDQVRJT05fU1VCSkVDVF9MT0JCWV9KT0lOEAEqpgEKDlN1cnJlbmRlclBoYXNlEh8KG1NVUlJFTkRFUl9QSEFTRV9VTlNQRUNJRklFRBAAEhoKFlNVUlJFTkRFUl9QSEFTRV9MT0NLRUQQARIdChlTVVJSRU5ERVJfUEhBU0VfQVZBSUxBQkxFEAISGgoWU1VSUkVOREVSX1BIQVNFX1ZPVElORxADEhwKGFNVUlJFTkRFUl9QSEFTRV9DT09MRE9XThAEKoEBCg5EZXBsb3ltZW50UmluZxIfChtERVBMT1lNRU5UX1JJTkdfVU5TUEVDSUZJRUQQABIXChNERVBMT1lNRU5UX1JJTkdfREVWEAESGwoXREVQTE9ZTUVOVF9SSU5HX1NUQUdJTkcQAhIYChRERVBMT1lNRU5UX1JJTkdfUFJPRBADQhuqAhhXYXJJblNwYWNlLlByb3RvY29sLldpcmViBnByb3RvMw");

/**
 * @generated from enum warinspace.v2.Team
 */
export enum Team {
  /**
   * @generated from enum value: TEAM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TEAM_BLUE = 1;
   */
  BLUE = 1,

  /**
   * @generated from enum value: TEAM_RED = 2;
   */
  RED = 2,

  /**
   * @generated from enum value: TEAM_SPECTATOR = 3;
   */
  SPECTATOR = 3,
}

/**
 * Describes the enum warinspace.v2.Team.
 */
export const TeamSchema: GenEnum<Team> = /*@__PURE__*/
  enumDesc(file_warinspace_v2_common, 0);

/**
 * @generated from enum warinspace.v2.TeamPreference
 */
export enum TeamPreference {
  /**
   * @generated from enum value: TEAM_PREFERENCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TEAM_PREFERENCE_BLUE = 1;
   */
  BLUE = 1,

  /**
   * @generated from enum value: TEAM_PREFERENCE_RED = 2;
   */
  RED = 2,

  /**
   * @generated from enum value: TEAM_PREFERENCE_AUTO = 3;
   */
  AUTO = 3,
}

/**
 * Describes the enum warinspace.v2.TeamPreference.
 */
export const TeamPreferenceSchema: GenEnum<TeamPreference> = /*@__PURE__*/
  enumDesc(file_warinspace_v2_common, 1);

/**
 * @generated from enum warinspace.v2.PlayerState
 */
export enum PlayerState {
  /**
   * @generated from enum value: PLAYER_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLAYER_STATE_TIMED_SHIELD = 1;
   */
  TIMED_SHIELD = 1,

  /**
   * @generated from enum value: PLAYER_STATE_HEAL_IN_RADIUS = 2;
   */
  HEAL_IN_RADIUS = 2,

  /**
   * @generated from enum value: PLAYER_STATE_STEALTH = 3;
   */
  STEALTH = 3,

  /**
   * @generated from enum value: PLAYER_STATE_SCRAP_IN_RADIUS = 4;
   */
  SCRAP_IN_RADIUS = 4,

  /**
   * @generated from enum value: PLAYER_STATE_ABSORBTION = 5;
   */
  ABSORBTION = 5,

  /**
   * @generated from enum value: PLAYER_STATE_DAMAGE_IN_RADIUS = 6;
   */
  DAMAGE_IN_RADIUS = 6,

  /**
   * @generated from enum value: PLAYER_STATE_DAMAGE_BOOSTED = 7;
   */
  DAMAGE_BOOSTED = 7,

  /**
   * @generated from enum value: PLAYER_STATE_SELF_DAMAGE_IN_RADIUS = 8;
   */
  SELF_DAMAGE_IN_RADIUS = 8,

  /**
   * @generated from enum value: PLAYER_STATE_GODMODE = 9;
   */
  GODMODE = 9,
}

/**
 * Describes the enum warinspace.v2.PlayerState.
 */
export const PlayerStateSchema: GenEnum<PlayerState> = /*@__PURE__*/
  enumDesc(file_warinspace_v2_common, 2);

/**
 * @generated from enum warinspace.v2.StatId
 */
export enum StatId {
  /**
   * @generated from enum value: STAT_ID_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: STAT_ID_MOVE_SPEED = 1;
   */
  MOVE_SPEED = 1,

  /**
   * @generated from enum value: STAT_ID_MAX_HEALTH = 2;
   */
  MAX_HEALTH = 2,

  /**
   * @generated from enum value: STAT_ID_FIRING_RANGE = 3;
   */
  FIRING_RANGE = 3,

  /**
   * @generated from enum value: STAT_ID_DAMAGE = 4;
   */
  DAMAGE = 4,

  /**
   * @generated from enum value: STAT_ID_MAX_DRONES = 5;
   */
  MAX_DRONES = 5,
}

/**
 * Describes the enum warinspace.v2.StatId.
 */
export const StatIdSchema: GenEnum<StatId> = /*@__PURE__*/
  enumDesc(file_warinspace_v2_common, 3);

/**
 * @generated from enum warinspace.v2.UpgradePath
 */
export enum UpgradePath {
  /**
   * @generated from enum value: UPGRADE_PATH_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: UPGRADE_PATH_ZERO = 1;
   */
  ZERO = 1,

  /**
   * @generated from enum value: UPGRADE_PATH_ONE = 2;
   */
  ONE = 2,

  /**
   * @generated from enum value: UPGRADE_PATH_TWO = 3;
   */
  TWO = 3,
}

/**
 * Describes the enum warinspace.v2.UpgradePath.
 */
export const UpgradePathSchema: GenEnum<UpgradePath> = /*@__PURE__*/
  enumDesc(file_warinspace_v2_common, 4);

/**
 * @generated from enum warinspace.v2.LoginStatus
 */
export enum LoginStatus {
  /**
   * @generated from enum value: LOGIN_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LOGIN_STATUS_LOGGED_IN = 1;
   */
  LOGGED_IN = 1,

  /**
   * @generated from enum value: LOGIN_STATUS_LOGGED_OUT = 2;
   */
  LOGGED_OUT = 2,

  /**
   * @generated from enum value: LOGIN_STATUS_BAD_CREDENTIALS = 3;
   */
  BAD_CREDENTIALS = 3,

  /**
   * @generated from enum value: LOGIN_STATUS_SESSION_STOLEN = 4;
   */
  SESSION_STOLEN = 4,

  /**
   * @generated from enum value: LOGIN_STATUS_LOGGED_OUT_AND_FORGET = 5;
   */
  LOGGED_OUT_AND_FORGET = 5,

  /**
   * @generated from enum value: LOGIN_STATUS_INVALID_EMAIL = 6;
   */
  INVALID_EMAIL = 6,

  /**
   * @generated from enum value: LOGIN_STATUS_USERNAME_OR_EMAIL_TAKEN = 7;
   */
  USERNAME_OR_EMAIL_TAKEN = 7,
}

/**
 * Describes the enum warinspace.v2.LoginStatus.
 */
export const LoginStatusSchema: GenEnum<LoginStatus> = /*@__PURE__*/
  enumDesc(file_warinspace_v2_common, 5);

/**
 * @generated from enum warinspace.v2.ModCommandType
 */
export enum ModCommandType {
  /**
   * @generated from enum value: MOD_COMMAND_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MOD_COMMAND_TYPE_KILL_PLAYER = 1;
   */
  KILL_PLAYER = 1,

  /**
   * @generated from enum value: MOD_COMMAND_TYPE_KICK_PLAYER = 2;
   */
  KICK_PLAYER = 2,

  /**
   * @generated from enum value: MOD_COMMAND_TYPE_RANDOMISE_NAME = 3;
   */
  RANDOMISE_NAME = 3,

  /**
   * @generated from enum value: MOD_COMMAND_TYPE_TOGGLE_FREEZE = 4;
   */
  TOGGLE_FREEZE = 4,
}

/**
 * Describes the enum warinspace.v2.ModCommandType.
 */
export const ModCommandTypeSchema: GenEnum<ModCommandType> = /*@__PURE__*/
  enumDesc(file_warinspace_v2_common, 6);

/**
 * @generated from enum warinspace.v2.DebugCommandType
 */
export enum DebugCommandType {
  /**
   * @generated from enum value: DEBUG_COMMAND_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DEBUG_COMMAND_TYPE_GRANT_CREDITS = 1;
   */
  GRANT_CREDITS = 1,

  /**
   * @generated from enum value: DEBUG_COMMAND_TYPE_GRANT_SCRAP_SELF = 2;
   */
  GRANT_SCRAP_SELF = 2,

  /**
   * @generated from enum value: DEBUG_COMMAND_TYPE_GRANT_SCRAP_EVERYONE = 3;
   */
  GRANT_SCRAP_EVERYONE = 3,

  /**
   * @generated from enum value: DEBUG_COMMAND_TYPE_SET_TIMESCALE = 4;
   */
  SET_TIMESCALE = 4,
}

/**
 * Describes the enum warinspace.v2.DebugCommandType.
 */
export const DebugCommandTypeSchema: GenEnum<DebugCommandType> = /*@__PURE__*/
  enumDesc(file_warinspace_v2_common, 7);

/**
 * @generated from enum warinspace.v2.ProductType
 */
export enum ProductType {
  /**
   * @generated from enum value: PRODUCT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PRODUCT_TYPE_DECAL = 1;
   */
  DECAL = 1,

  /**
   * @generated from enum value: PRODUCT_TYPE_TAG_OR_TRAIL = 2;
   */
  TAG_OR_TRAIL = 2,

  /**
   * @generated from enum value: PRODUCT_TYPE_SKIN = 3;
   */
  SKIN = 3,

  /**
   * @generated from enum value: PRODUCT_TYPE_PAYMENT_TILE = 4;
   */
  PAYMENT_TILE = 4,
}

/**
 * Describes the enum warinspace.v2.ProductType.
 */
export const ProductTypeSchema: GenEnum<ProductType> = /*@__PURE__*/
  enumDesc(file_warinspace_v2_common, 8);

/**
 * @generated from enum warinspace.v2.LobbyVisibility
 */
export enum LobbyVisibility {
  /**
   * @generated from enum value: LOBBY_VISIBILITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LOBBY_VISIBILITY_PUBLIC = 1;
   */
  PUBLIC = 1,

  /**
   * @generated from enum value: LOBBY_VISIBILITY_PRIVATE = 2;
   */
  PRIVATE = 2,
}

/**
 * Describes the enum warinspace.v2.LobbyVisibility.
 */
export const LobbyVisibilitySchema: GenEnum<LobbyVisibility> = /*@__PURE__*/
  enumDesc(file_warinspace_v2_common, 9);

/**
 * @generated from enum warinspace.v2.BotDifficulty
 */
export enum BotDifficulty {
  /**
   * @generated from enum value: BOT_DIFFICULTY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BOT_DIFFICULTY_RECRUIT = 1;
   */
  RECRUIT = 1,

  /**
   * @generated from enum value: BOT_DIFFICULTY_REGULAR = 2;
   */
  REGULAR = 2,

  /**
   * @generated from enum value: BOT_DIFFICULTY_VETERAN = 3;
   */
  VETERAN = 3,

  /**
   * @generated from enum value: BOT_DIFFICULTY_ELITE = 4;
   */
  ELITE = 4,
}

/**
 * Describes the enum warinspace.v2.BotDifficulty.
 */
export const BotDifficultySchema: GenEnum<BotDifficulty> = /*@__PURE__*/
  enumDesc(file_warinspace_v2_common, 10);

/**
 * @generated from enum warinspace.v2.LobbyCloseReason
 */
export enum LobbyCloseReason {
  /**
   * @generated from enum value: LOBBY_CLOSE_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LOBBY_CLOSE_REASON_LEFT = 1;
   */
  LEFT = 1,

  /**
   * @generated from enum value: LOBBY_CLOSE_REASON_MATCH_ENDED = 2;
   */
  MATCH_ENDED = 2,

  /**
   * @generated from enum value: LOBBY_CLOSE_REASON_RETIRED = 3;
   */
  RETIRED = 3,
}

/**
 * Describes the enum warinspace.v2.LobbyCloseReason.
 */
export const LobbyCloseReasonSchema: GenEnum<LobbyCloseReason> = /*@__PURE__*/
  enumDesc(file_warinspace_v2_common, 11);

/**
 * @generated from enum warinspace.v2.NotificationSubject
 */
export enum NotificationSubject {
  /**
   * @generated from enum value: NOTIFICATION_SUBJECT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTIFICATION_SUBJECT_LOBBY_JOIN = 1;
   */
  LOBBY_JOIN = 1,
}

/**
 * Describes the enum warinspace.v2.NotificationSubject.
 */
export const NotificationSubjectSchema: GenEnum<NotificationSubject> = /*@__PURE__*/
  enumDesc(file_warinspace_v2_common, 12);

/**
 * @generated from enum warinspace.v2.SurrenderPhase
 */
export enum SurrenderPhase {
  /**
   * @generated from enum value: SURRENDER_PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SURRENDER_PHASE_LOCKED = 1;
   */
  LOCKED = 1,

  /**
   * @generated from enum value: SURRENDER_PHASE_AVAILABLE = 2;
   */
  AVAILABLE = 2,

  /**
   * @generated from enum value: SURRENDER_PHASE_VOTING = 3;
   */
  VOTING = 3,

  /**
   * @generated from enum value: SURRENDER_PHASE_COOLDOWN = 4;
   */
  COOLDOWN = 4,
}

/**
 * Describes the enum warinspace.v2.SurrenderPhase.
 */
export const SurrenderPhaseSchema: GenEnum<SurrenderPhase> = /*@__PURE__*/
  enumDesc(file_warinspace_v2_common, 13);

/**
 * @generated from enum warinspace.v2.DeploymentRing
 */
export enum DeploymentRing {
  /**
   * @generated from enum value: DEPLOYMENT_RING_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DEPLOYMENT_RING_DEV = 1;
   */
  DEV = 1,

  /**
   * @generated from enum value: DEPLOYMENT_RING_STAGING = 2;
   */
  STAGING = 2,

  /**
   * @generated from enum value: DEPLOYMENT_RING_PROD = 3;
   */
  PROD = 3,
}

/**
 * Describes the enum warinspace.v2.DeploymentRing.
 */
export const DeploymentRingSchema: GenEnum<DeploymentRing> = /*@__PURE__*/
  enumDesc(file_warinspace_v2_common, 14);

